import { Component, OnInit, Signal, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';

import { faCheckCircle, faCircleExclamation, faCog, faSpinner } from '@fortawesome/free-solid-svg-icons';

import { SidebarService } from '../core/services/sidebar.service';
import { LoginService } from '../core/services/login.service';
import { SessionStorageService } from '../core/services/session-storage.service';
import { ControlValuesMatchValidator } from '../core/validators/control-values-match.directive';
import { ManagementUser } from '../core/models/management-user.model';


@Component({
    selector: 'wf-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent implements OnInit {
  userData: ManagementUser | null = null ;
  isFILUser: boolean | undefined = false ;
  demoModeEnabled: Signal<boolean> = inject(SessionStorageService).isDemoMode ;
  isChangingPassword: boolean = false ;
  successMessage: string = "";
  changePasswordForm = this.fb.group({
    currentPassword: ['', Validators.required],
    newPassword: ['', Validators.compose([
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(20),
      Validators.pattern(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9_!?]){8,20}$/)
    ])],
    confirmPassword: ['', Validators.required ]
  },
  {
    validator: ControlValuesMatchValidator('newPassword', 'confirmPassword'),
  }) ;
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  successIcon = faCheckCircle ;
  errorIcon = faCircleExclamation ;
  settingsIcon = faCog ;
  loadingIcon = faSpinner ;

  constructor(
    public loginService: LoginService,
    public sidebarService: SidebarService,
    public sessionStorageService: SessionStorageService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.userData = this.sessionStorageService.getUserData() ;
    if (this.userData) {
      this.isFILUser = this.userData.isFILUser() ;
    }
  }

  changePassword() {
    this.isChangingPassword = true ;
    this.successMessage = '';

    this.loginService.changePassword(this.currentPassword?.value, this.newPassword?.value).subscribe({
      next: (status) => {
        this.isChangingPassword = false ;

        if (status === 200)
        {
          this.successMessage = 'Password Successfully Updated!' ;
          this.currentPassword?.setErrors(null) ;
          this.newPassword?.setErrors(null) ;
          this.confirmPassword?.setErrors(null) ;
        }
        else if (status === 400)
        {
          this.newPassword?.setErrors({ pattern: true }) ;
        }
        else if (status === 401)
        {
          this.currentPassword?.setErrors({ incorrect: true }) ;
        }
      }
    })
  }

  currentPasswordToggle() {
    this.showCurrentPassword = !this.showCurrentPassword;

    return this.showCurrentPassword;
  }
  newPasswordToggle() {
    this.showNewPassword = !this.showNewPassword;

    return this.showNewPassword;
  }

  confirmPasswordToggle() {
    this.showConfirmPassword = !this.showConfirmPassword;

    return this.showConfirmPassword;
  }

  toggleManagementDemoMode() {
    const userData = this.sessionStorageService.getUserData();
    if (userData) {
      this.sessionStorageService.toggleDemoModeEnabled();
      this.sessionStorageService.setUserData(userData);
    }
  }

  // Utility methods to get our form controls
  get currentPassword() {
    return this.changePasswordForm.get('currentPassword') ;
  }

  get newPassword() {
    return this.changePasswordForm.get('newPassword') ;
  }

  get confirmPassword() {
    return this.changePasswordForm.get('confirmPassword') ;
  }
}
